export const serviceAreasData = [
    "Campbelltown NSW",
    "Ambarvale NSW",
    "Appin NSW",
    "Currans Hills NSW",
    "Claymore NSW",
    "Macarthur NSW",
    "Menangle NSW",
    "Leumeah NSW",
    "Raby NSW",
    "St Andrew's NSW",
    "St Helen's Park NSW",
    "Ruse NSW",
    "Minto NSW",
    "Ingleburn NSW",
    "Glenfield NSW",
    "Camden NSW",
    "Camden south NSW",
    "Oran park NSW",
    "Gregory hills NSW",
    "Eagle vale NSW",
    "Douglas Park NSW",
    "Elderslie NSW",
    "Wilton NSW",
    "Spring farm NSW",
    "Cobbity NSW",
    "Mount Annan NSW",
    "Phesant Nest NSW",
    "Cowdor NSW",
    "Denham court NSW",
    "Edmondson park NSW",
    "Austral NSW",
    "Razorback NSW",
    "Liverpool NSW",
    "Picton NSW",
    "Thilmere NSW",
    "Bargo NSW",
    "Bowral NSW",
    "Kearns NSW",
    "Goulburn NSW",
    "Rosemeadow NSW",
    "Airds NSW",
    "Gledswood Hills NSW",
    "Leppington NSW",
    "Smeaton Grange NSW",
    "Menangle park NSW",
    "The oaks NSW",
    "Oak dale NSW",
    "Buxton NSW",
    "Mossvale NSW",
    "Mittagong NSW",
    "Manly Vale NSW",
    "Dee Why NSW",
    "Brookvale NSW",
    "Curl Curl NSW",
    "Freshwater NSW",
    "Narrabeen NSW",
    "Warriewood NSW",
    "Mona Vale NSW",
    "Avalon Beach NSW",
    "Newport NSW",
    "Palm Beach NSW",
    "Collaroy NSW",
    "Collaroy Plateau NSW",
    "Forestville NSW",
    "Casula NSW",
    "Prestons NSW",
    "Hoxton Park NSW",
    "Cecil Hills NSW",
    "Wetherill Park NSW",
    "Smithfield NSW",
    "Fairfield NSW",
    "Cabramatta NSW",
    "Canley Vale NSW",
    "Bonnyrigg NSW",
    "Edensor Park NSW",
    "Bossley Park NSW",
    "Abbotsbury NSW",
    "Sutherland NSW",
    "Miranda NSW",
    "Caringbah NSW",
    "Cronulla NSW",
    "Woolooware NSW",
    "Gymea NSW",
    "Kirrawee NSW",
    "Jannali NSW",
    "Como NSW",
    "Engadine NSW",
    "Loftus NSW",
    "Heathcote NSW",
    "Menai NSW",
    "Bangor NSW",
    "Illawong NSW",
  ];